import { Flex, FlexProps } from "@chakra-ui/react";
import { ReactNode } from "react";

import { OFText } from "design_system/components/OFText";
import { textStylesType } from "src/typography";

type Props = FlexProps & {
  titleTranslation?: string;
  dataTranslation?: string;
  children?: ReactNode;
  value?: string | number;
  textStyle?: textStylesType;
  color?: string;
};

export const SummaryItemWrapper = ({
  titleTranslation,
  dataTranslation,
  children,
  value,
  textStyle,
  color,
  ...props
}: Props) => {
  return (
    <Flex flexDirection="column">
      <Flex justifyContent="space-between" alignItems="center" {...props}>
        {children || <OFText textStyle={textStyle || "body2"}>{titleTranslation}</OFText>}
        <OFText textStyle={textStyle || "body2"} color={color}>
          {value || dataTranslation}
        </OFText>
      </Flex>
    </Flex>
  );
};
